module.exports = __webpack_public_path__ + "img/area-graph-light.e8d101eb.svg";